export default {"src":"/_next/static/media/nissan.c75803ff.svg","height":170,"width":170,"blurWidth":0,"blurHeight":0};